import type { Vfm } from "vue-final-modal";
import { createVfm } from "vue-final-modal";

export default defineNuxtPlugin((nuxtApp) => {
  const vfm: Vfm = createVfm();

  nuxtApp.vueApp.use(vfm);
});
